import { useApiRequestHelper } from '@/composables/useApiRequestHelper.js'
import { useGetConfigVar } from '@/composables/useGetConfigVar.js'
import { setBearerToken } from '@/plugins/axios'
import { isObject } from 'lodash'
import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useAppStore = defineStore(
  'app',
  () => {
    const { $apiAuthenticatedRequest, $apiUnauthenticatedRequest } = useApiRequestHelper()

    const apiUrl = ref(null)
    const bearerToken = ref(null)

    const showBackButton = ref(false)
    const configVars = ref({})

    const errorIcon = ref(null)
    const errorTitle = ref(null)
    const errorMessage = ref(null)
    const errorCode = ref(null)

    watch(
      bearerToken,
      (newToken) => {
        setBearerToken(newToken)
      },
      { immediate: true },
    )

    const getConfigVarsUnauthenticated = async () => {
      return await $apiUnauthenticatedRequest.index('config-vars').then(({ data }) => {
        data.forEach((item) => {
          configVars.value[item.key] = item.value
        })
      })
    }

    const getConfigVarsAuthenticated = async () => {
      return await $apiAuthenticatedRequest.index('config-vars').then(({ data }) => {
        data.forEach((item) => {
          configVars.value[item.key] = item.value
        })
      })
    }

    const getVerificationMethodsCount = () => {
      const featureFlag = useGetConfigVar('ENGINEER_APP_VERIFICATION_METHODS')

      if (!featureFlag || !isObject(featureFlag)) {
        return 0
      }

      return Object.entries(featureFlag).filter(
        ([method, enabled]) => (method === 'EMAIL' || method === 'SMS') && enabled === true,
      ).length
    }

    const reset = () => {
      apiUrl.value = null
      bearerToken.value = null
      showBackButton.value = false
      configVars.value = {}
      errorTitle.value = null
      errorMessage.value = null
      errorCode.value = null
    }

    return {
      apiUrl,
      bearerToken,
      errorIcon,
      errorTitle,
      errorMessage,
      errorCode,
      showBackButton,
      configVars,
      getConfigVarsUnauthenticated,
      getConfigVarsAuthenticated,
      getVerificationMethodsCount,
      reset,
    }
  },
  { persist: true },
)
